'use client'

import {Tooltip} from 'antd'
import {TooltipPropsWithTitle} from 'antd/es/tooltip'
import {CircleHelp} from 'lucide-react'

import theme from '@/src/config/theme'

interface IProps extends TooltipPropsWithTitle {
  title: string
}

const InputTooltip = ({title, ...props}: IProps) => {
  return (
    <Tooltip {...props} title={title} showArrow>
      <CircleHelp color={theme.colors.gray4} size={20} />
    </Tooltip>
  )
}

export default InputTooltip
